import React from "react";

const LocationIcon = () => {
  return (
    <svg
      width="34"
      height="42"
      viewBox="0 0 34 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 1C8.16333 1 1 7.71562 1 16C1 19.5487 2.668 22.6694 4.514 25.375L15.912 40.4725C16.162 40.8037 16.568 41 17 41C17.432 41 17.838 40.8037 18.088 40.4725L29.486 25.375C31.25 23.1488 33 19.5487 33 16C33 7.71562 25.8367 1 17 1ZM27.7247 25.375H27.718L17 39.125L6.282 25.375H6.27533C4.646 23.1681 2.33333 19.6244 2.33333 16C2.33333 8.40625 8.9 2.25 17 2.25C25.1 2.25 31.6667 8.40625 31.6667 16C31.6667 19.6244 29.1873 23.3631 27.7247 25.375Z"
        fill="#3F3F3F"
        stroke="#3F3F3F"
      />
      <path
        d="M16.9993 7.25C11.8447 7.25 7.66602 11.1675 7.66602 16C7.66602 20.8325 11.8447 24.75 16.9993 24.75C22.154 24.75 26.3327 20.8325 26.3327 16C26.3327 11.1675 22.154 7.25 16.9993 7.25ZM16.9993 23.5C12.5813 23.5 8.99935 20.1419 8.99935 16C8.99935 11.8581 12.5813 8.5 16.9993 8.5C21.4173 8.5 24.9993 11.8581 24.9993 16C24.9993 20.1419 21.4173 23.5 16.9993 23.5Z"
        fill="#3F3F3F"
        stroke="#3F3F3F"
      />
    </svg>
  );
};

export default LocationIcon;
